import React from 'react';
import useParamWorkspaceId from '@/hook/useParamWorkspaceId';
import PATH_PAGE from '@/router/path';
import { getListAiModule } from '@/service/ai';
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
} from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { AIServiceIcon, LLMServiceIcon, OneClickDeployIcon } from '@/components/ui/icons';
import { ChevronRight } from 'lucide-react';
import useNavigateWithParams from '@/hook/navigate/useNavigateWithParams';

const AiListModule = () => {
  const { workspaceId } = useParamWorkspaceId();
  const modules = getListAiModule();
  const navigate = useNavigateWithParams();

  return (
    <div className="container pt-10">
      <div className="mb-8">
        <div className="flex items-center gap-4">
          <AIServiceIcon className="h-8 w-8 text-primary" />
          <h1 className="text-3xl font-bold leading-tight">AI as a service</h1>
        </div>
        <p className="mt-1 max-w-2xl text-muted-foreground">
          Discover ready-to-use AI services via API, starting with OCR and more
          to come. Instantly integrate each module into your business or project
          with ease and flexibility.
        </p>
      </div>
      <div className="mt-8 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-2">
        {modules.map((mod) => {
          const Icon = mod.icon || AIServiceIcon;
          return (
            <Card
              key={mod.id}
              className="group relative cursor-pointer overflow-hidden border border-border bg-card transition-all duration-200 hover:border-primary hover:shadow-xl"
              onClick={() =>
                navigate(
                  PATH_PAGE.dashboard.ai.module(workspaceId, mod.id).overview
                )
              }
            >
              <CardHeader className="flex min-h-[170px] flex-col items-start gap-2 p-6">
                <CardTitle className="mb-1 text-xl font-semibold transition-colors group-hover:text-primary flex items-center gap-2">
                  <span>{mod.title}</span>
                  <mod.icon className="h-5 w-5 text-muted-foreground" />
                </CardTitle>
                <CardDescription className="mt-1 text-base leading-relaxed">
                  {mod.description}
                </CardDescription>
                <div className="flex flex-wrap gap-2 mt-2">
                  {mod.tags?.map((tag: string) => (
                    <span key={tag} className="text-xs rounded px-2 py-0.5 bg-primary/10 text-primary border border-primary/20">
                      {tag}
                    </span>
                  ))}
                </div>
                <div className="mt-2 text-sm font-medium text-muted-foreground">
                  {mod.price}
                </div>
                <Button
                  variant="ghost"
                  size="icon"
                  tabIndex={-1}
                  className="pointer-events-none absolute right-4 top-4 opacity-0 transition-all group-hover:bg-primary/10 group-hover:opacity-100"
                >
                  <ChevronRight className="h-5 w-5 text-muted-foreground" />
                </Button>
              </CardHeader>
            </Card>
          );
        })}
      </div>
    </div>
  );
};
export default AiListModule;
